import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type React from "react";
import {memo} from "react";

import {UploadImageIcon} from "../../react/components/Icons/UploadImageIcon";
import {Center} from "../ui/center";
import {Pressable} from "../ui/pressable";
import {Text} from "../ui/text";
import {VStack} from "../ui/vstack";

type Props = {
    onOpen: () => void;
    isDrag?: boolean;
};

const style = tva({
    base: "p-4 border border-dashed rounded-lg bg-transparent",
    variants: {
        isDrag: {
            true: "border-primary-600",
            false: "border-blueGray-300"
        }
    }
});

const UploadPlaceholder: React.FC<Props> = ({isDrag, onOpen}) => {
    return (
        <Pressable onPress={onOpen}>
            <Center className={style({isDrag})}>
                <UploadImageIcon size="lg" stroke="blueGray.600" />
                <VStack className="mt-2" space="sm">
                    <Text textAlign="center" variant="sm">
                        Drag your image(s) or{" "}
                        <Text color="blue.600" variant="sm">
                            browse
                        </Text>
                    </Text>
                </VStack>
            </Center>
        </Pressable>
    );
};

export default memo(UploadPlaceholder);
